import { Link } from '@tanstack/router'
import { useEffect, useState } from 'react'

import useCommonEmblaCarousel from '../../hooks/useCommonEmblaCarousel'
import useDimensions from '../../hooks/useDimensions'
import type { ApiResponse } from '../../types/api'
import type { PromotionObj } from '../../types/promotion'
import { api } from '../../utils/api-client'
import { kebabCase } from '../../utils/string'

const PlatformBanner = () => {
  const { isDesktop } = useDimensions()

  const [emblaRef] = useCommonEmblaCarousel()

  const [promoList, setPromoList] = useState<PromotionObj[]>([])

  useEffect(() => {
    const getPromotions = async () => {
      const response = await api.post<ApiResponse<PromotionObj[]>>(
        '/ajax_check.php',
        {
          type: 'get_promotion_list',
        },
      )

      const { status, info } = response.data
      if (status === 1 && info) {
        setPromoList(info)
      }
    }
    getPromotions()
  }, [])

  return (
    <div className="pt-3 pb-0 px-3 aspect-[1121_/_561] xl:aspect-[1200_/_250] xl:max-w-[1330px] xl:mt-4 xl:mb-0 xl:mx-auto xl:p-0">
      {promoList.length > 0 && (
        <div className="embla" ref={emblaRef}>
          <div className="embla__container">
            {promoList.map(item => (
              <Link
                key={item.id}
                to="/promotions/$promoId"
                params={{
                  promoId: `${item.id}-${kebabCase(item.title)}`,
                }}
                className="embla__slide">
                <div className="w-full">
                  <img
                    className="w-full aspect-[1121_/_561] object-cover rounded-[15px] xl:aspect-[1200_/_250] xl:rounded-[25px]"
                    src={
                      isDesktop
                        ? item.bannerurl_2400_500
                        : item.bannerurl_mobile
                    }
                    alt={item.title}
                  />
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default PlatformBanner
